<template>
  <div id="userDbRowMenuTmpl">
    <div class="menu">
      <!-- Menu Items -->
      <el-form :model="menuData" ref="userDbRowMenuForm" id="userDbRowMenuForm" @submit.prevent>
        <template v-for="(menuItem, menuItemKey) in menuItems" :key="menuItemKey">
          <div :id="menuItem.id" :class="['property', menuItem.id, {'section-wrapper': menuItem.show}]">
            <div class="menu-item" v-if="menuItem.id === menuItemsId.column && menuItem.show">
              <div class="title">{{menuItem.name}}</div>

              <div class="content submit-user-db-row-form column">
                <el-button-group class="cstm-smart-text-col-group-btn">
                  <template v-for="(itemPropertyValue, itemPropValKey) in numberOfColumnOptions" :key="itemPropValKey">
                    <el-button
                      @click="handleMenuItemChange(itemPropertyValue, menuItemKey)"
                      :class="[itemPropValKey, {'is-selected': (menuData.numOfColumns === itemPropertyValue)}]">{{itemPropertyValue}}
                    </el-button>
                  </template>
                </el-button-group>
              </div>
            </div>

            <div class="menu-item" v-if="menuItem.id === menuItemsId.schedule && menuItem.show">
              <playtime-form ref="newPlaytimeForm"
                :playtimeProp="playtimeFormData"
                :parentAccessorComponentProp="'smartTextPageMenu'"
                :mediaSelectionProp="[]"
                @playtime-form-change="handlePlaytimeFormChange($event)">
              </playtime-form>
            </div>
          </div>
        </template>
      </el-form>

      <el-button v-if="showSubmitButton" @click="handleSubmitButtonClick" class="cstm-btn-gradient width-125 submit-user-db-row-form-btn">{{$t('label.ok')}}</el-button>
    </div>
  </div>
</template>
<script src="./smart-text-menu.js"></script>
<style lang="scss" src="./smart-text-menu.scss"></style>
